import axios from 'axios';

axios.defaults.withCredentials = true;